import classNames from 'classnames'
import { useFormContext } from 'react-hook-form'
import { connect, DataItem } from 'scrivito'

import { StringText } from '@/Atomic/Atoms/StringText'
import { CustomField } from '@/Atomic/Organisms/CustomField'
import { FormBody, FormFields, FormGroup } from '@/Atomic/Templates/Form'
import { getDataItemFormMap } from '@/utils/CRUD/read/dataItem/getDataItemMap'

interface DataItemFormBodyProps {
  dataItem: DataItem
  isEditing?: boolean
}

export const DataItemFormBody: React.FC<DataItemFormBodyProps> = connect(
  ({ dataItem, isEditing }) => {
    const { getValues, watch } = useFormContext()
    const groups = getDataItemFormMap(dataItem, getValues, watch)

    return (
      <FormBody>
        {groups.map((group) => (
          <FormGroup key={group.name}>
            <StringText variant="title">{group.title}</StringText>
            <FormFields className={classNames({ display: !isEditing })}>
              {group.fields.map((field) => (
                <CustomField
                  key={field.fieldKey}
                  fieldMap={field}
                  isEditing={isEditing}
                  className="form-field"
                  isReadonly={field.fieldSchema?.readonly}
                />
              ))}
            </FormFields>
          </FormGroup>
        ))}
      </FormBody>
    )
  },
)
